export default {
  "content": "<style>.st1{fill:#fff}</style><path fill=\"#4a2e86\" d=\"M0 0h32v32H0z\"/><path class=\"st1\" d=\"M8.37 15.41H6.09v9.31H3.01v-9.31H.71v-2.59h2.3v-3.7h3.07v3.7h2.28v2.59zM8.05 23.14c0-1.08.89-1.99 2.02-1.99 1.06 0 1.99.91 1.99 1.99s-.94 1.97-1.99 1.97c-1.13 0-2.02-.89-2.02-1.97zM13.53 8.76c0-1.06.84-1.87 1.9-1.87s1.9.82 1.9 1.87c0 1.08-.84 1.9-1.9 1.9s-1.9-.82-1.9-1.9zm3.48 4.06v11.91h-3.14V12.82h3.14zM24.99 12.48c3.74 0 6.22 2.59 6.22 6.27 0 3.7-2.47 6.27-6.22 6.27s-6.24-2.57-6.24-6.27c0-3.67 2.5-6.27 6.24-6.27zm0 9.73c1.85 0 3.07-1.42 3.07-3.46s-1.22-3.46-3.07-3.46c-1.87 0-3.07 1.42-3.07 3.46s1.2 3.46 3.07 3.46z\"/>",
  "attrs": {
    "version": "1.1",
    "id": "Layer_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "x": "0",
    "y": "0",
    "viewBox": "0 0 32 32",
    "xml:space": "preserve"
  }
};